import React from 'react';
import { useModal } from '@pcmp/react-providers';

import { ContactSider } from '@/components/siders/contact';
import { useTrackInteraction } from '@/lib/hooks/tracking';

const FeedbackButton = () => {
  const { openModal } = useModal();
  const [trackInteraction] = useTrackInteraction();

  const goToSection = () => {
    openModal({
      component: ContactSider,
      props: {},
    });
    // Track events to get user insights
    trackInteraction({
      content: 'feedback-button',
      type: 'click',
      action: 'contact',
    });
  };

  return (
    <div className="z-30 fixed top-1/2 right-[-25px] rotate-[270deg]">
      <button
        className="p-3 bg-sky-700 rounded-tl-[10px] rounded-tr-[10px]"
        onClick={goToSection}
        data-testid="feedback-button"
      >
        <span className="text-white font-bold leading-[23px]">Feedback</span>
      </button>
    </div>
  );
};

export default FeedbackButton;
